import server from "./server";

export const getRequestsApi = async () => {
  const response = await server().get("/requests");
  return response.data;
};

export const getSingleRequestApi = async (id) => {
  const response = await server().get(`/requests/${id}`);
  return response.data;
};

export const addRequestApi = async (payload) => {
  const response = await server().post("/requests", payload);
  return response.data;
};

export const editRequestApi = async ({ id, data }) => {
  const response = await server().put(`/requests/${id}`, data);
  return response.data;
};

export const deleteRequestApi = async (id) => {
  const response = await server().delete(`/requests/${id}`);
  return response.data;
};
